#import "../fragments/AutomationEditorFields.graphql"

mutation ActivateAutomation($id: ID!) {
  activateAutomation(id: $id) {
    automation {
      ...AutomationEditorFields
    }
    issues {
      nodeId
      code
      exitRuleId
    }
  }
}
